import type { InformationPackageStatusApi } from '../Services/InformationPackageApiProviderTypes';

// The pipeline step the package last completed. Named after the steps rather
// than shortened to "Ready" / "Processing" — which step a package stopped at is
// what tells you what is missing from it.
export const STATUS_LABELS: Record<InformationPackageStatusApi, string> = {
  QUEUED: 'Queued',
  ARTIFACT_EXTRACTED: 'Artifact extracted',
  SEMANTIC_INDEXED: 'Semantic indexed',
  SUMMARIZED: 'Summarized',
  KNOWLEDGE_INDEXED: 'Knowledge indexed',
};

// Falls back to the raw value: the pipeline can grow a step before this page
// knows about it, and an unlabelled status still says more than an empty field.
export const statusLabel = (status?: InformationPackageStatusApi | null): string =>
  (status && STATUS_LABELS[status]) ?? status ?? '';
